import { ImageElement } from '@kontent-ai/gatsby-components';
import { StyledImageContainer, StyledShadowcastImageContainer } from './ImageContainer.styles';

type ImageContainerProps = {
  image: Queries.SECTION_INTRODUCTIONFragment['sectionIntroductionElements']['image'];
  hasShadowcastBackground: boolean;
  isReversed: boolean;
};

const ImageContainer = ({ image, hasShadowcastBackground, isReversed }: ImageContainerProps) => {
  if (!image?.value) {
    return null;
  }

  const imageValue = {
    ...image.value,
    url: image.value.url,
    description: image.value.description ?? '',
    height: image.value.height ?? 128,
    width: image.value.width ?? 128,
    image_id: image.value.url,
  };

  const imageElement = (
    <ImageElement
      alt={imageValue.description}
      height={imageValue.height}
      image={imageValue}
      width={imageValue.width}
    />
  );

  return hasShadowcastBackground ? (
    <StyledShadowcastImageContainer>{imageElement}</StyledShadowcastImageContainer>
  ) : (
    <StyledImageContainer isReversed={isReversed}>{imageElement}</StyledImageContainer>
  );
};

export default ImageContainer;
